import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Formulario from "./components/Formulario";
import FormularioQuimica from "./components/FormularioQuimica";
import logoEVQ from "./assets/imgs/EIQ-logo.png";
import logoFCNM from "./assets/imgs/logo-fcnm.svg";
import "./assets/css/formulario.css";

export class Router extends Component {
    render() {
        return (
            <BrowserRouter>
                <Switch>                    
                    <Route path="/fquimica" >
                        <div>
                            {/*<center className="colorFcnm">*/}
                            {/*    <h4 style={{ marginTop: "10px" }}>III Escuela de Ingeniería Química</h4>*/}
                            {/*    <h5>2024</h5>                                */}
                            {/*</center>*/}
                            {/*<br />*/}
                            {/*<h5>Información para las inscripciones</h5>*/}
                            {/*<br />*/}
                            <FormularioQuimica />
                        </div>                        
                    </Route>
                    <Route path="/fcibb" >
                        <div>
                           {/*<center>*/}
                           {/*    <h4 style={{ marginTop: "10px" }}>VII Congreso Internacional de Biotecnolog&iacute;a y Biodiversidad 2025</h4>*/}
                           {/*    */}{/*<h5>CIBB 2025</h5>*/}
                           {/*    */}{/*<h5>- MODALIDAD VIRTUAL -</h5>*/}
                           {/*</center>*/}
                           {/*<br />*/}
                           {/*<h5>Formulario de Registro: VII CIBB 2025</h5>*/}
                           {/*<br />*/}
                           <Formulario />
                        </div>                        
                    </Route>
                    <Route path="" >
                        <div>
                        </div>
                    </Route>
                </Switch>
            </BrowserRouter>
        );
    }
}

export default Router;